import { render, staticRenderFns } from "./cadcobradores.vue?vue&type=template&id=27f19fe8&"
import script from "./cadcobradores.vue?vue&type=script&lang=js&"
export * from "./cadcobradores.vue?vue&type=script&lang=js&"
import style0 from "./cadcobradores.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports